/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 納品（受入）可能フラグ（火曜日）
 * @export
 * @interface EnableArrivalTue
 */
export interface EnableArrivalTue {
}

/**
 * Check if a given object implements the EnableArrivalTue interface.
 */
export function instanceOfEnableArrivalTue(value: object): value is EnableArrivalTue {
    return true;
}

export function EnableArrivalTueFromJSON(json: any): EnableArrivalTue {
    return EnableArrivalTueFromJSONTyped(json, false);
}

export function EnableArrivalTueFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableArrivalTue {
    return json;
}

export function EnableArrivalTueToJSON(json: any): EnableArrivalTue {
    return EnableArrivalTueToJSONTyped(json, false);
}

export function EnableArrivalTueToJSONTyped(value?: EnableArrivalTue | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

